import { render, staticRenderFns } from "./PaymentTermList.vue?vue&type=template&id=299972bd"
import script from "./PaymentTermList.vue?vue&type=script&lang=js"
export * from "./PaymentTermList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports